import { createModel } from "hox";
import { useState } from "react"
import { message } from "antd";
import { TablePaginationConfig } from "antd/lib/table";
import { DEFAULT_PAGE_SIZE, DEFAULT_FIRST_PAGE_NUM } from "@/utils/constants";
import { ISearchPage, ISelectOptions } from "@/types/AppTypes";
import useGlobalModel, { transPgToPagination } from "@/model/globalModel";
import { useLockFn } from "ahooks";
import { globalPrompt } from "@/components/message";
import { ids } from "@/views/projectCase/caseTypes";
import {  BusinessImgList, BusinessImgType, IBusinessDetail, IBusinessField, IBusinessImg, IUploadImg } from "./businessTypes";
import { businessService } from "./businessService";
import { useDictModel } from "../base/dict/dictModel";
import { DictCodeEnmu } from "@/types/AppDictEnums";
import { getCOSFileUrl } from "@/utils/uploadFile";

export const useBusinessModel = createModel(function () {
    const { user } = useGlobalModel()
    const {getSelectedDictOne} = useDictModel()
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    //列表数据
    const [dataSource, setDataSource] = useState<IBusinessDetail[]>([]);
    //查询条件
    const [searchParam, setSearchParam] = useState<IBusinessField>({});
    //分页参数
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    //表格多选id值
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    //表格选中的值
    const initImgList = {
        coopBrand: [] as IUploadImg[],
        business: [] as IUploadImg[],
        medal: [] as IUploadImg[],
        service: [] as IUploadImg[],
    }
    const [selectedRow, setSelectedRow] = useState<IBusinessField[]>([]);
    //新增图片
    const [addFormVal, setAddFormVal] = useState<IBusinessDetail>({}) //表单的值;
    const [addMd5List, setAddMd5List] = useState<BusinessImgList>(initImgList) //图片md5值;
    
    //编辑图片
    const [editFormVal, setEditFormVal] = useState<IBusinessDetail>({}) //表单的值;
    const [editMd5List, setEditMd5List] = useState<BusinessImgList>(initImgList) //图片md5值;

    const [categoryOption, setCategoryOption] = useState<ISelectOptions[]>([])

    //设置搜索value
    const updateSearchParam = (updateParam: IBusinessField) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    //重置搜索参数
    const resetSearchParam = () => {
        setSearchParam({});
        setSelectedRowKeys([]);
        loadData(initPgCfg, {});
    }
    //列表查询
    const loadData = async (page?: ISearchPage, searchValue: IBusinessField = searchParam) => {
        const searchParams = {
            ...searchValue,
            page: {
                pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
                pageNum: (page?.pageNum || page?.current) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
            }
        }
        let { retData } = await businessService.page(searchParams);
        const { items, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setDataSource(items);
    }
    //查询一条
    const getDetailEditOne = async (id: string) => {
        let { retData } = await businessService.one(id);
        const { list, ...from } = retData;
        const imgList = initImgList;
        await list?.forEach(item => {
            for (const key in imgList) {
                if (item.imgCategory === key) {
                    imgList[key as BusinessImgType].push({
                        uid: item.imgMd5,
                        title: item.imgTitle,
                        id: item.id,
                        url: getCOSFileUrl(item.imgMd5)
                        // url: `${fileUrl}/file/fetch?id=${item.imgMd5}`
                    } as IUploadImg)
                }
            }
        })
        setEditFormVal(from);
        setEditMd5List(imgList);
    }
    //关闭页签清不同状态缓存
    const resetAddCatch = async (type?: string) => {
        setAddFormVal({})
        setAddMd5List(initImgList);
    }
    const resetEditCatch = async (type?: string) => {
        setEditFormVal({});
        setEditMd5List(initImgList);
    }

    //新增国际案例
    const insertDetail = useLockFn(async (params: IBusinessField) => {
        
        let { retData } = await businessService.insert({
            ...params,
            createUser: user.userName,
        });
        return retData;
    })
    //编辑国际案例
    const editDetail = useLockFn(async (params: IBusinessField) => {
        let { retData } = await businessService.update({
            ...params,
            updateUser: user.userName,
        });
        return retData;
    })
    const onRemove = useLockFn(async (ids: ids ) => {
        let { retData } = await businessService.delete(ids)
        if (retData) {
            loadData();
            globalPrompt("message", { text: "国际案例删除成功", type: "success" })
        }
    })

    const initCategory = async () => {
        const options = await getSelectedDictOne(DictCodeEnmu.BUS)
        setCategoryOption(options)
    }
    return {
        initImgList,
        categoryOption,
        dataSource,
        searchParam,
        pgCfg,
        selectedRowKeys,
        initPgCfg,
        selectedRow,
        addFormVal,
        addMd5List,
        editFormVal,
        editMd5List,
        setSelectedRowKeys,
        setPgCfg,
        setSearchParam,
        setDataSource,
        updateSearchParam,
        resetSearchParam,
        loadData,
        setSelectedRow,
        insertDetail,
        editDetail,
        onRemove,
        setAddFormVal,
        setAddMd5List,
        setEditFormVal,
        setEditMd5List,
        getDetailEditOne,
        resetAddCatch,
        resetEditCatch,
        initCategory,
    }
})